import { useEffect } from 'react';

const API_URL = '';

const useVisitTracker = () => {
  useEffect(() => {
    const track = async () => {
      try {
        await fetch(`${API_URL}/api/public/track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            referrer: document.referrer || '',
            page: window.location.pathname,
          }),
        });
      } catch (err) { console.error('Visit tracking failed:', err); }
    };

    // Only track once per session
    if (!sessionStorage.getItem('ogd_tracked')) {
      track();
      sessionStorage.setItem('ogd_tracked', '1');
    }
  }, []);
};

export default useVisitTracker;
